import React from 'react';
import classNames from 'classnames';
import { Typography, TypographySecondary } from '../../foundations/typography';
import styles from './Carousel.module.scss';
var useCarouselTitle = function (_a) {
    var title = _a.title, subTitle = _a.subTitle, _b = _a.typography, typography = _b === void 0 ? 'default' : _b, _c = _a.withImage, withImage = _c === void 0 ? false : _c;
    if (!title)
        return null;
    if (typography === 'sebenta') {
        return (React.createElement(TypographySecondary, { id: classNames(styles.sebentaTitle), font: "sebenta", size: 28 }, title));
    }
    if (subTitle && !withImage) {
        return (React.createElement(Typography, { styleAs: "sectionHeading", element: "h2", noMargins: true, id: classNames(styles.forceFontSize) }, title));
    }
    return (React.createElement(Typography, { styleAs: "screenHeadingSmall", element: "h2", noMargins: true }, title));
};
export default useCarouselTitle;
//# sourceMappingURL=useCarouselTitle.js.map